import React, { useState } from 'react';
import { Plus, X } from 'lucide-react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

export const PollDialog = ({ open, onClose, onCreate }) => {
  const [question, setQuestion] = useState('');
  const [options, setOptions] = useState(['', '']);
  const [multiple, setMultiple] = useState(false);
  const valid = question.trim() && options.filter((o) => o.trim()).length >= 2;
  const submit = () => { onCreate({ question: question.trim(), options: options.map((o) => o.trim()).filter(Boolean), multiple, votes: {} }); setQuestion(''); setOptions(['', '']); setMultiple(false); onClose(); };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="poll-dialog">
        <DialogHeader><DialogTitle>Nueva encuesta</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Pregunta</Label><Input value={question} onChange={(e) => setQuestion(e.target.value)} placeholder="¿Qué día hacemos la junta?" className="mt-1" data-testid="poll-question" /></div>
          <div className="space-y-2">
            <Label>Opciones</Label>
            {options.map((o, i) => (
              <div key={i} className="flex gap-2">
                <Input value={o} onChange={(e) => setOptions(options.map((x, j) => (j === i ? e.target.value : x)))} placeholder={`Opción ${i + 1}`} data-testid={`poll-option-${i}`} />
                {options.length > 2 && <Button type="button" variant="ghost" size="icon" onClick={() => setOptions(options.filter((_, j) => j !== i))} aria-label="Quitar"><X className="h-4 w-4" /></Button>}
              </div>
            ))}
            {options.length < 6 && <Button type="button" variant="outline" size="sm" onClick={() => setOptions([...options, ''])} className="gap-1" data-testid="poll-add-option"><Plus className="h-3.5 w-3.5" />Agregar opción</Button>}
          </div>
          <label className="flex items-center justify-between rounded-md border border-slate-200 px-3 py-2 text-sm"><span>Permitir varias respuestas</span><Switch checked={multiple} onCheckedChange={setMultiple} data-testid="poll-multiple" /></label>
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose}>Cancelar</Button>
          <Button type="button" disabled={!valid} onClick={submit} className="bg-[#0f1f4b] hover:bg-[#1a2f66]" data-testid="poll-create">Publicar encuesta</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
